import React from "react";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ element }) => {
  const isAuthenticated = () => {
    const token = localStorage.getItem("AccessTokenMMA");
    return !!token;
  };

  return isAuthenticated() ? element : <Navigate to="/login" replace />;
};

export default PrivateRoute;